import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeLearningProtectResourcesModel extends BaseOperationModel {
  learningDuration: string|null;
  learningEndDate: Date|null;
  orgUnitEndLearningId: string|null;
  countries: string[];
}
